import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'lib-pim-create-model-modal',
    templateUrl: './pim-create-model-modal.component.html',
    styleUrls: ['./pim-create-model-modal.component.css'],
    standalone: false
})
export class PimCreateModelModalComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
